import { Injectable } from '@angular/core';
import { ApiService } from 'src/app/shared/services/api.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ServicesService {


    constructor(private api : ApiService) { }
  
  viewColom(payload:any){
    const url = `${environment.New_BASE_DOMAIN}account-service/userView/addOrUpdate`;
    return this.api.post(url,payload);
  } 
  getUserTableListByUserId(userId:any){
    const url = `${environment.New_BASE_DOMAIN}account-service/userView/getUserTableListByUserId?userId=${userId}`;
    return this.api.get(url);
  }

}
